import React from 'react'
import graphql from 'babel-plugin-relay/macro'
import { fetchQuery } from 'config/amber-relay'
import { Form } from 'semantic-ui-react'
export default function SubscriptionMacSearch(props) {

  const ipRegex = /\b(?:\d{1,3}\.){1,3}\d{1,3}\b/;
  const macRegex = /\b(?:[0-9A-Fa-f]{2}:){2,}[0-9A-Fa-f]{2}\b/
  const macGponRegex = /^([a-zA-Z0-9]{6,12}$)/

  const lineas = props.numRows || 20;
  let subscriptionIds = [];
  const fetch = async where => {
    const { SubscriptionProducts } = await fetchQuery(
      graphql`
            query SubscriptionMacSearchQuery($where: SubscriptionProductWhere){
                SubscriptionProducts(where: $where, first: 20){
                  edges{
                    node{
                      
                      subscriptionId
                      
                    }
                  }
                }
              }
            `,
      { where, first: lineas }
    )
    const getIds = node => {
      subscriptionIds.push(node.subscriptionId);
    }
    SubscriptionProducts.edges.map(({ node }) => {
      //console.log(node)
      getIds(node);
    })
    return subscriptionIds

  }

  return <Form.Field>

    <label>{props.label}</label>
    <Form.Input
      onChange={async (_, { value }) => {
        if (ipRegex.test(value)) {
          props.onChange(await fetch({ ip: { like: `%${value.trim()}%` } }))
        }
        if (macRegex.test(value)) {
          props.onChange(await fetch({ wanMac: { like: `%${value.toUpperCase().trim()}%` } }))
        }
        if (macGponRegex.test(value)) {
          props.onChange(await fetch({ macAddress: { like: `%${value.toUpperCase().trim()}%` } }))
        }
        if (value.length === 0) props.onChange(null)
      }}
      placeholder={props.placeholder}
    ></Form.Input>
  </Form.Field>
}

SubscriptionMacSearch.defaultProps = {
  label: 'WanMac / IP',
  placeholder: '24:DB:12 o 192.168'
}